var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "van-button",
    _vm._g(
      _vm._b(
        {
          attrs: {
            round: "",
            type: _vm.$attrs.type ? _vm.$attrs.type : "primary"
          }
        },
        "van-button",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6eb7f6b2", esExports)
  }
}


// WEBPACK FOOTER //
// src/components-mall/button/index.vue